import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
import { UserDto } from '../interfaces/dtos/users';

@Injectable({
  providedIn: 'root',
})
export class UsersService extends BaseHttpService {
  protected endPoint: string = 'Global/Users';
  private readonly url = `${this.environment.apiIContactBaseUrlAdmin}/api/v1`;

  public fetchUsers(): Observable<UserDto[]> {
    return this.http.get<UserDto[]>(`${this.url}/${this.endPoint}`);
  }
}
